<template>
    <div>
      <div v-if="!slug">
        <section>
          <h3>Bonus dos Parceiros</h3>
        </section>
        <section class="grid-flex wrap">
          <div class="item flex-1 box flex middle center-txt">
            <a href="https://kiwify.app/5GKJu0z?afid=erSmYjiO" target="_blank">
                <div class="box-content">
                    <img width="180" src="@/assets/img/inter/Logo-NI-Preta.png"/>
                    <p>
                        <small>Crie automações de whatsapp rápido e fácil!</small>
                    </p>
                </div>
            </a>
          </div>
        </section>
  
        <section class="flex center-txt margin-top-l">
          <p>
            Quer ter seu produto nos bonus? Entre em contato em:
            <a href="mailto:contato@unicotracker.com.br"
              >contato@unicotracker.com.br</a
            >
          </p>
        </section>
      </div>
    </div>
  </template>
  
  <script>
  import { mapState } from "vuex";
  
  export default {
    name: "bonus",
    components: {
    },
    props: ["slug"],
    data() {
      return {
        loading: false,
      };
    },
    mounted() {},
    computed: {
      ...mapState({
        user: (state) => state.user,
        account: (state) => state.account,
      }),
    },
    methods: {
      checkResource(name) {
        return this.account && this.account.resources.includes(name);
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .box {
    min-width: 300px;
    min-height: 130px;
    margin-top: 16px;
    margin-left: 0px !important;
    margin-right: 20px;
  
    .box-content {
      cursor: pointer;
    }
  
    a {
      width: 100%;
      height: 100%;
    }
  }
  
  .disabled-box {
    background: #e8e8e8;
    > a {
      cursor: none;
    }
  }
  
  .tag {
    background: var(--primary);
    color: #fff;
    padding: 4px 12px;
    border-radius: 40px;
    font-size: 10px;
    font-weight: 600;
  }
  </style>
  